import React from 'react';
import { PhotoSwipe } from 'react-photoswipe';
import 'react-photoswipe/lib/photoswipe.css';

type Props = {
  isOpen: boolean;
  srcs: string[];
  onClose: () => void;
  startIndex?: number;
  imageWidth?: number;
  imageHeight?: number;
};

const ImageGallery = ({
  startIndex = 0,
  imageWidth = 1500,
  imageHeight = 1000,
  isOpen,
  srcs,
  onClose,
}: Props) => {
  const galleryItems = srcs.map((src) => ({
    src,
    w: imageWidth,
    h: imageHeight,
  }));

  const galleryOptions = {
    index: startIndex,
    shareEl: false,
  };

  return (
    <PhotoSwipe
      isOpen={isOpen}
      items={galleryItems}
      onClose={onClose}
      options={galleryOptions}
    />
  );
};

export default ImageGallery;
